import React from "react";
import { object } from "prop-types";

import CardImage from "../../../atoms/CardImage";

import { removeHtml } from "../../../utils/utils";
import { useDevice } from "../../../utils/react-utils";

import "./organism1.m.css";

const Organism1 = ({ story }) => {
  const { mobile, desktop } = useDevice();

  const alternativeHeroImage = story.alternative?.home?.default?.["hero-image"];

  const { "hero-image-caption": heroImageCaption, "hero-image-attribution": heroImageAttribution } =
    alternativeHeroImage || story;

  return (
    <div>
      <CardImage
        story={story}
        aspectRatio={desktop ? [16, 9] : [3, 2]}
        imageType={desktop ? "image16x9" : "image3x2"}
        className="card-with-image-zoom"
        linkEnable={true}
        widths={[400, 480, 720]}
      />
      {!mobile && heroImageCaption && (
        <figcaption styleName="caption">
          {heroImageCaption && <span>{removeHtml(heroImageCaption)}</span>}
          {heroImageAttribution && (
            <span styleName={`${heroImageCaption && heroImageAttribution ? "bar" : ""}`}>
              {removeHtml(heroImageAttribution)}
            </span>
          )}
        </figcaption>
      )}
    </div>
  );
};

Organism1.propTypes = {
  story: object.isRequired,
};

export default Organism1;
